import { Dispatch } from "react-redux";
import { OrderedSet } from "immutable";
import { CART_GRID_VIEW } from "constants/action-types";
import { ActionCreatorMap, IStore } from "reducers";
import { CartGridView, ICustomView } from "reducers/cart-grid-view";
import { ILineItem } from "constants/order-types";
import me from "models/me";

export type ActionDef = {
    setRowIds: [typeof CART_GRID_VIEW.ROWIDS, OrderedSet<string>];

    setSelected: [
        typeof CART_GRID_VIEW.SELECTED.SET,
        { ids: OrderedSet<string>; selectedItems: Array<Pick<ILineItem, "_id" | "product">> },
    ];
    deselectAll: [typeof CART_GRID_VIEW.SELECTED.DESELECT_ALL, void];

    showSelectedSizes: [typeof CART_GRID_VIEW.SELECTED.SHOW, void];
    hideSelectedSizes: [typeof CART_GRID_VIEW.SELECTED.HIDE, void];
    setShownSizes: [typeof CART_GRID_VIEW.SIZES_SHOWN_SET, OrderedSet<string>];

    update: [typeof CART_GRID_VIEW.UPDATE, Partial<CartGridView>];
    updateState: [typeof CART_GRID_VIEW.GRID_STATE, CartGridView["gridState"]];
    clear: [typeof CART_GRID_VIEW.CLEAR, void];
};

const cardGridViewActions: ActionCreatorMap<ActionDef> = {
    setRowIds: (ids, isCrossFrame = true) => ({
        type: CART_GRID_VIEW.ROWIDS,
        payload: ids,
        isCrossFrame,
    }),
    setSelected: ({ ids, selectedItems }, isCrossFrame = true) => ({
        type: CART_GRID_VIEW.SELECTED.SET,
        payload: { ids, selectedItems },
        isCrossFrame,
    }),
    deselectAll: (isCrossFrame = true) => ({
        type: CART_GRID_VIEW.SELECTED.DESELECT_ALL,
        isCrossFrame,
    }),

    showSelectedSizes: (isCrossFrame = true) => ({
        type: CART_GRID_VIEW.SELECTED.SHOW,
        isCrossFrame,
    }),
    hideSelectedSizes: (isCrossFrame = true) => ({
        type: CART_GRID_VIEW.SELECTED.HIDE,
        isCrossFrame,
    }),
    setShownSizes: (ids, isCrossFrame = true) => ({
        type: CART_GRID_VIEW.SIZES_SHOWN_SET,
        payload: ids,
        isCrossFrame,
    }),

    update: (payload: Partial<CartGridView>, isCrossFrame = false) => ({
        type: CART_GRID_VIEW.UPDATE,
        payload,
        isCrossFrame,
    }),
    updateState: (payload: CartGridView["gridState"], isCrossFrame = false) => ({
        type: CART_GRID_VIEW.GRID_STATE,
        payload,
        isCrossFrame,
    }),
    clear: (isCrossFrame = false) => ({
        type: CART_GRID_VIEW.CLEAR,
        isCrossFrame,
    }),
};

export const fetchCustomGridViews = () => ({
    type: CART_GRID_VIEW.CUSTOM_VIEWS.FETCH,
    payload: { url: `/api/v3.0/user/${me._id}/table-view/cart-grid-view` },
});

export const createCustomGridView = (data: ICustomView) => ({
    type: CART_GRID_VIEW.CUSTOM_VIEWS.CREATE,
    payload: { url: `/api/v3.0/user/${me._id}/table-view/cart-grid-view`, body: data },
});

export const updateCustomGridView = (id: string, data: ICustomView) => ({
    type: CART_GRID_VIEW.CUSTOM_VIEWS.UPDATE,
    payload: { url: `/api/v3.0/user/${me._id}/table-view/${id}`, body: data },
});

export const deleteCustomGridView = (id: string) => ({
    type: CART_GRID_VIEW.CUSTOM_VIEWS.DELETE,
    payload: { url: `/api/v3.0/user/${me._id}/table-view/${id}` },
});

export default {
    updateData: (data: Partial<CartGridView["data"]>) => (dispatch: Dispatch<{}>, getState: () => IStore) =>
        dispatch({
            type: CART_GRID_VIEW.UPDATE,
            payload: {
                data: {
                    ...getState().cartGridView.data,
                    ...data,
                },
            },
        }),
    ...cardGridViewActions,
};
